import React from 'react';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-8 md:px-12 py-16 sm:py-24">
        <h1 className="text-5xl sm:text-6xl tracking-tight leading-none font-black mb-8" data-testid="disclaimer-title">
          Disclaimer
        </h1>
        <div className="prose prose-lg max-w-none text-base sm:text-lg leading-relaxed">
          <p className="mb-6">
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            General Information
          </h2>
          <p className="mb-6">
            The information provided by The Pune Perspective is for general informational purposes only. All information 
            on the site is provided in good faith, however we make no representation or warranty of any kind, express 
            or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any 
            information on the site.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Reviews and Opinions
          </h2>
          <p className="mb-6">
            The reviews, opinions, and ratings expressed on this website are those of the individual authors and do not 
            necessarily reflect the official policy or position of any car manufacturer or dealer.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            External Links
          </h2>
          <p className="mb-6">
            Our website may contain links to external websites that are not provided or maintained by us. We do not 
            guarantee the accuracy, relevance, timeliness, or completeness of any information on these external websites.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Professional Advice
          </h2>
          <p className="mb-6">
            The information on this website is not intended as professional advice. Before making any purchasing decisions, 
            we recommend consulting with qualified professionals and conducting your own research.
          </p>

          <h2 className="text-3xl sm:text-4xl tracking-tight leading-tight font-bold mt-12 mb-6">
            Changes to This Disclaimer
          </h2>
          <p className="mb-6">
            We may update this disclaimer from time to time. We encourage you to review this page periodically for any changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
